module.exports = __webpack_public_path__ + "img/checkout-right-desktop.ffd86efd.svg";